// extracted by css-extract-rspack-plugin
export default {"cls1":"LoadingDots-cls1_h_h","cls2":"LoadingDots-cls2_OnZ LoadingDots-cls1_h_h","loading-dot":"LoadingDots-loading-dot_98k"};